import { ElementAttachPointPosition, ElementsRoot, JElement } from './types/catalog-types';
import { GroupItem } from './types/composition';

export type AttachControlType = 'used' | 'free-optional' | 'free-required';

export type AttachControlInfo = {
    groupId: string
    elementId: string
    type: AttachControlType
    position: ElementAttachPointPosition
    profile: string
    required: boolean
    attachedToId?: string
    attachedToPosition?: ElementAttachPointPosition
}

export function resolveAttachControlsInfo(groups: GroupItem[], elements: JElement[]): AttachControlInfo[] {

    const attachControlInfo: AttachControlInfo[] = [];

    for(const group of groups) {

        for(const element of group.elements) {

            const catalogElement = elements.find(e => e.id === element.element);
    
            if(!catalogElement) {
                continue;
            }
    
            for(const attachPoint of catalogElement.attach ?? []) {
    
                if(element.attachedTo && element.attachedTo.ownPosition === attachPoint.position ||
    
                    group.elements.some(e => (
                            e.attachedTo?.otherPosition === attachPoint.position &&
                            e.attachedTo?.otherId == element.id
                        ))
                    ) {
    
                    attachControlInfo.push({
                        groupId: group.id,
                        elementId: element.id,
                        type: 'used',
                        position: attachPoint.position,
                        profile: attachPoint.profile,
                        required: attachPoint.required ?? false,
                        attachedToId: element.attachedTo?.otherId,
                        attachedToPosition: element.attachedTo?.otherPosition
                    })
    
                } else {
                        
                    attachControlInfo.push({
                        groupId: group.id,
                        elementId: element.id,
                        type: attachPoint.required ? 'free-required' : 'free-optional',
                        position: attachPoint.position,
                        profile: attachPoint.profile,
                        required: attachPoint.required ?? false
                    })
                }
            }

        }

    }

    return attachControlInfo;

}